import { absolutePath } from "./absolutePath";

const onboarding = {
  get: () => absolutePath("admin/onboarding_settings"),
  upsert: () => absolutePath("admin/onboarding_settings/upsert"),
};

// TODO: Remove after feature flag welcome_page_home_tabs_enabled is removed
const welcomeSpaces = {
  get: () => absolutePath("admin/welcome_spaces"),
  put: () => absolutePath("admin/welcome_spaces"),
};

const welcomeData = {
  get: () => absolutePath("admin/welcome_data"),
  put: () => absolutePath("admin/welcome_data"),
};

const designConfig = {
  get: () => absolutePath("admin/branded_mobile_app"),
  put: () => absolutePath("admin/branded_mobile_app"),
};

const brandedAppsBuilderPages = {
  get: () => absolutePath("admin/branded_mobile_app_builders"),
  upsert: () => absolutePath("admin/branded_mobile_app_builders/upsert"),
};

export const brandedAppsBuilderUI = {
  onboarding,
  welcomeData,
  welcomeSpaces,
  designConfig,
  brandedAppsBuilderPages,
};
